export default __webpack_public_path__ + "static/media/payment.3fe491ea.svg";